const env = import.meta.env;

export const useEmulators = env.VITE_USE_EMULATORS === "1";

/** Cloud Functions 的區域（與 functions/src/index.ts 的 setGlobalOptions 相同） */
export const functionsRegion = "asia-east1";

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || (useEmulators ? "demo-key" : ""),
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || (useEmulators ? "demo-gametogo.firebaseapp.com" : ""),
  projectId: env.VITE_FIREBASE_PROJECT_ID || (useEmulators ? "demo-gametogo" : ""),
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || (useEmulators ? "demo-gametogo.appspot.com" : ""),
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: env.VITE_FIREBASE_APP_ID || (useEmulators ? "demo-app" : ""),
};
